import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowLeftIcon } from '../../../assets/images/arrow-left.svg';
import {
  NavIconWrapper, Wrapper, HeaderNameContainer
} from './styles';
import {StyledTitle} from "../../CustomAntdComponents/Typography";

type Props = {
  name?: string;
  stepText?: string;
  navigateHandler?: () => void;
}

function StepNavigationHeader({ name, stepText, navigateHandler }: Props) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (navigateHandler) {
      navigateHandler();
    } else {
      navigate(-1);
    }
  };

  return (
    <Wrapper>
      <NavIconWrapper onClick={handleNavigate}>
        <ArrowLeftIcon width={15} height={15} />
      </NavIconWrapper>

      {name && (
        <HeaderNameContainer>
          <StyledTitle level={5} align="center" style={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>
            {name} {stepText && <span style={{ color: "#6B7280" }}>{stepText}</span>}
          </StyledTitle>
        </HeaderNameContainer>
      )}
    </Wrapper>
  );
}

StepNavigationHeader.defaultProps = {
  name: undefined,
  stepText: undefined,
  navigateHandler: undefined,
};

export default StepNavigationHeader;
